import * as React from "react"

import { CATEGORIES_ROUTES, USER_ROLE } from "@constants"
import AppLayout from "Layout"
import CategoriesPage from "./index"


export const CategoriesRoutes = {
    path: CATEGORIES_ROUTES.PATH,
    title: CATEGORIES_ROUTES.TITLE,
    icon: 'layer-group',
    iconWeight: 'light',
    element: <AppLayout />,
    description: CATEGORIES_ROUTES.SUBTITLE,
    access: USER_ROLE.ADMIN,
    children: [{
        element: <CategoriesPage />,
        index: true
    }]
}
